import PropTypes from "prop-types";
import Link from "next/link";
import { oxford } from "@services/format/string";
import styles from "@components/Typography/typography.module.css";
import cardStyles from "./styles/teamcard.module.css";

export function TeamCard({ team }) {
  return (
    <div className={cardStyles.wrapper}>
      <h3 className={cardStyles.title}>{team.title}</h3>
      {team.description && (
        <div className={cardStyles.descriptionWrapper}>
          <div className={cardStyles.description}>
            <p className={styles.paragraph}>{team.description}</p>
          </div>
        </div>
      )}
      <article className={cardStyles.postingWrapper}>
        {team.postings?.map((posting) => {
          return (
            <Link href={`/careers/${posting.slug.current}`} key={posting._id}>
              <div className={cardStyles.posting}>
                <h4>{posting.title}</h4>
                <span>{oxford(posting.location, "and")}</span>
                <span>{oxford(posting.role, "and")}</span>
                <span>&rarr;</span>
              </div>
            </Link>
          );
        })}
      </article>
    </div>
  );
}

TeamCard.propTypes = {
  team: PropTypes.object.isRequired,
};
